/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemHeartWrapper_viewer$ref = any;
export type CartItem_viewer$ref = any;
export type CartItem_viewer = {
    readonly " $fragmentRefs": ItemHeartWrapper_viewer$ref;
    readonly " $refType": CartItem_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItem_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userIds",
            "type": null
        },
        {
            "kind": "RootArgument",
            "name": "loadPortfolioData",
            "type": null
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ItemHeartWrapper_viewer",
            "args": [
                {
                    "kind": "Variable",
                    "name": "loadPortfolioData",
                    "variableName": "loadPortfolioData"
                },
                {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                }
            ]
        }
    ]
} as any);
(node as any).hash = '833f631637f0eda8e31dd9ffa7c4e5b5';
export default node;
